import Autocomplete from '@mui/material/Autocomplete';
import { useFetch } from '../hooks/useFecth';
import { TextField } from '@mui/material';

export default function SelectClub({ title = '', onChange, extraOptions = [], ...rest }) {
    const { name, value } = rest || {};

    const { data, isValidating } = useFetch(`clubs`, { params: { paged: false, status: true } });
    const options = [
        ...extraOptions,
        ...(data?.map(({ id, name }) => ({
            id,
            label: name,
        })) || []),
    ];

    const selected = options?.find(item => String(item.id) === String(value)) || null;

    return (
        <>
            <Autocomplete
                title={title || 'Selecione o clube'}
                {...rest}
                options={options || []}
                value={selected || null}
                loading={isValidating}
                onChange={(e, newValue) => onChange({ target: { name, value: newValue?.id || null } })}
                renderInput={params => <TextField {...params} label={title || rest.label || 'Selecione o clube'} />}
            />
        </>
    );
} 